import { render, staticRenderFns } from "./GeneralConfigs.vue?vue&type=template&id=3b4d88ec&scoped=true&"
import script from "./GeneralConfigs.vue?vue&type=script&setup=true&lang=js&"
export * from "./GeneralConfigs.vue?vue&type=script&setup=true&lang=js&"
import style0 from "./GeneralConfigs.vue?vue&type=style&index=0&id=3b4d88ec&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3b4d88ec",
  null
  
)

export default component.exports